import { CartButton } from "@/components/Buttons/CartButton";
import theme from "@/styles/themes/theme";
import { Card, CardActions, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { Ticket } from "@phosphor-icons/react";

import { styles } from "./styles";
import { CardMenuProps } from "./types";

export const CardDetalhe: React.FC<CardMenuProps> = ({ image, title, parceiro, km, categoryId, productId, partnerId }) => {
  return (
    <Stack
      justifyContent="space-between"
      gap={4}
      direction={{
        md: "row",
        xs: "column"
      }}
      maxHeight={{ lg: 350, sm: "auto" }}
    >
      <Card sx={{ borderRadius: 4, flex: 1, display: "flex", justifyContent: "center" }}>
        <CardMedia component="img" width="90%" height="100%" image={image} alt="parceiro" style={{ objectFit: "contain", width: "90%" }} />
      </Card>

      <Card sx={{ borderRadius: 4, flex: 1, justifyContent: "space-between", display: "flex", flexDirection: "column" }}>
        <CardContent sx={{ bgcolor: theme.palette.info.main }}>
          <Typography color={theme.palette.common.white} fontWeight={400} variant="h5">
            {title}
          </Typography>

          <Typography color={theme.palette.common.white} variant="body2">
            {parceiro}
          </Typography>
        </CardContent>

        <Card css={styles.cardbilhete} sx={{ margin: 2, minHeight: 100 }}>
          <CardContent css={styles.carddetalhe__bilhete}>
            <Stack css={styles.carddetalhe__logo}>
              <Ticket size={24} color={theme.palette.common.white} />
            </Stack>

            <Stack>
              <Typography color={theme.palette.warning.main} fontWeight={600} fontSize={20}>
                {km}
              </Typography>

              <Typography sx={{ mb: 1.5 }} color={theme.palette.grey[700]} fontSize={16} variant="body1">
                Troque seus pontos KMV e compre com beneficios exclusivos.
              </Typography>
            </Stack>
          </CardContent>
        </Card>

        <CardActions sx={{ marginLeft: 2, marginBottom: 1 }}>
          <CartButton
            title="Resgatar Voucher"
            buttonType="RESGATE"
            categoryId={categoryId}
            partnerId={partnerId}
            productId={productId}
            buttonProps={{ variant: "contained", color: "primary", sx: { color: theme.palette.common.black, width: { xs: "100%", sm: "auto" } } }}
          />
        </CardActions>
      </Card>
    </Stack>
  );
};
